var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAuthorizationImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 1080,
    viewBox: "0 0 1200 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 1080,
    fill: "#282827"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 1080.9,
    fill: "url(#paint0_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1200 0H0V1080.9H1200V0ZM498.5 964C734.602 964 926 773.721 926 539C926 304.279 734.602 114 498.5 114C262.398 114 71 304.279 71 539C71 773.721 262.398 964 498.5 964Z",
    fill: "url(#paint1_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1200 0H0V341.814C82.1312 181.069 249.449 71 442.5 71C716.709 71 939 293.067 939 567C939 840.933 716.709 1063 442.5 1063C249.449 1063 82.1312 952.931 0 792.186V1080.9H1200V0Z",
    fill: "url(#paint2_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M608.973 1080.9C901.514 1018.82 1121 759.041 1121 448C1121 274.118 1052.41 116.258 940.804 0L1200 0V1080.9H608.973ZM339.027 1080.9C206.481 1052.77 88.9319 984.059 0 888.382V1080.9H339.027ZM7.19586 0L0 0V7.61777C2.37824 5.05914 4.77695 2.5198 7.19586 0Z",
    fill: "url(#paint3_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.558 505.28H599.389V532.643H605.558V505.28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.224 505.28L630.502 522.868V505.28H636.357V532.639H630.735L617.498 515.091V532.639H611.603V505.28H617.224Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.997 505.28L661.961 510.399H648.526V517.124H660.865V522.284H648.526V532.639H642.356V505.28H661.997Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.011 524.845C665.148 522.929 664.721 520.944 664.721 518.887C664.721 517.273 664.991 515.688 665.523 514.139C666.055 512.59 666.853 511.178 667.925 509.899C669.198 508.334 670.693 507.132 672.414 506.285C674.13 505.438 675.94 504.962 677.842 504.857H677.918C678.128 504.857 678.301 504.937 678.446 505.095C678.591 505.248 678.676 505.446 678.7 505.68V509.076C678.7 509.572 678.426 509.847 677.878 509.899C676.709 510.004 675.589 510.335 674.521 510.896C673.453 511.456 672.559 512.207 671.829 513.143C670.423 514.861 669.718 516.801 669.718 518.964C669.718 520.267 669.992 521.521 670.54 522.735C671.088 523.946 671.866 524.982 672.881 525.841C674.598 527.249 676.524 527.951 678.656 527.951C679.957 527.951 681.206 527.677 682.403 527.132C683.6 526.584 684.616 525.789 685.446 524.748C686.147 523.913 686.675 522.998 687.025 521.993C687.38 520.993 687.553 519.968 687.553 518.927C687.553 517.443 687.227 516.063 686.578 514.784C686.449 514.526 686.385 514.264 686.385 514.006C686.385 513.667 686.538 513.368 686.852 513.106C687.062 512.977 687.464 512.703 688.061 512.287C688.657 511.872 689.036 511.61 689.193 511.505C689.403 511.376 689.596 511.311 689.782 511.311C690.201 511.311 690.511 511.505 690.72 511.896C691.97 514.082 692.594 516.442 692.594 518.968C692.594 520.609 692.324 522.203 691.776 523.756C691.228 525.305 690.422 526.721 689.354 527.996C688.081 529.637 686.485 530.892 684.575 531.763C682.665 532.639 680.666 533.07 678.583 533.07C676.943 533.07 675.355 532.792 673.82 532.231C672.285 531.671 670.923 530.856 669.722 529.791C668.102 528.407 666.869 526.761 666.011 524.845Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.01 544.349L618.284 561.941V544.349H624.143V571.712H618.517L605.284 554.16V571.712H599.389V544.349H605.01Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.956 544.349V549.472H636.312V555.41H649.51V560.534H636.312V566.593H651.383V571.712H630.143V544.349H650.956Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.363 544.349V549.589H668.01V571.712H661.836V549.589H653.523V544.349H676.363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.302 544.349L689.04 564.991L694.746 544.349H700.795L706.573 564.991L712.275 544.349H718.602L709.539 571.712H703.176L697.672 552.207L692.046 571.712H685.683L676.665 544.349H683.302Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.705 563.918C720.842 562.002 720.415 560.017 720.415 557.96C720.415 556.346 720.685 554.761 721.217 553.212C721.749 551.663 722.547 550.251 723.619 548.972C724.892 547.407 726.387 546.205 728.108 545.358C729.824 544.511 731.634 544.035 733.536 543.93H733.612C733.822 543.93 733.995 544.01 734.14 544.168C734.285 544.321 734.37 544.519 734.394 544.753V548.149C734.394 548.645 734.12 548.92 733.572 548.972C732.403 549.077 731.283 549.408 730.215 549.969C729.147 550.529 728.253 551.28 727.523 552.216C726.117 553.934 725.412 555.874 725.412 558.037C725.412 559.34 725.686 560.598 726.234 561.808C726.782 563.019 727.56 564.055 728.575 564.914C730.292 566.322 732.218 567.024 734.35 567.024C735.651 567.024 736.9 566.75 738.097 566.205C739.294 565.657 740.309 564.862 741.139 563.821C741.841 562.986 742.368 562.071 742.719 561.066C743.074 560.066 743.247 559.041 743.247 558C743.247 556.516 742.921 555.136 742.272 553.857C742.143 553.599 742.078 553.337 742.078 553.075C742.078 552.736 742.231 552.437 742.546 552.175C742.755 552.046 743.158 551.772 743.755 551.356C744.351 550.941 744.73 550.679 744.887 550.574C745.097 550.445 745.29 550.38 745.475 550.38C745.894 550.38 746.205 550.574 746.41 550.965C747.659 553.151 748.284 555.511 748.284 558.037C748.284 559.678 748.014 561.276 747.466 562.825C746.918 564.374 746.112 565.79 745.044 567.065C743.771 568.706 742.175 569.961 740.265 570.832C738.351 571.708 736.356 572.139 734.273 572.139C732.633 572.139 731.045 571.861 729.51 571.3C727.975 570.74 726.613 569.925 725.412 568.86C723.796 567.48 722.563 565.83 721.705 563.918Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.229 571.712L765.893 563.894H765.305H759.603V571.712H753.434V544.349H765.301C772.449 544.349 776.507 547.786 776.507 553.849C776.507 558.069 774.71 561.118 771.39 562.684L777.208 571.712H770.229ZM759.607 558.734H765.309C768.706 558.734 770.66 557.169 770.66 554.043C770.66 550.993 768.71 549.468 765.309 549.468H759.607V558.734Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M799.658 571.712L791.808 560.57L787.863 564.951V571.712H781.698V544.349H787.863V556.778L799.231 544.349H806.371L796.104 555.765L807.076 571.712H799.658Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819.947 549.355C817.876 549.355 816.473 550.098 816.473 551.582C816.473 556.625 831.037 553.809 831 563.66C831 569.017 826.354 571.905 820.302 571.905C815.813 571.905 811.319 570.187 808.237 567.569L810.695 562.526C813.508 565.027 817.489 566.633 820.378 566.633C822.917 566.633 824.44 565.693 824.44 564.015C824.44 558.855 809.873 561.865 809.873 552.171C809.873 547.209 814.128 544.079 820.455 544.079C824.283 544.079 828.107 545.253 830.839 547.048L828.458 552.167C825.568 550.449 822.131 549.355 819.947 549.355Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.267 511.09C536.013 512.689 535.51 515.805 536.834 518.234C540.128 524.28 542 531.214 542 538.586C542 562.089 522.972 581.141 499.5 581.141C476.028 581.141 457 562.089 457 538.586C457 516.774 473.389 498.795 494.509 496.321C497.251 496 499.5 493.789 499.5 491.024V477.006C499.5 474.241 497.254 471.98 494.5 472.185C460.108 474.745 433 503.496 433 538.586C433 575.361 462.773 605.172 499.5 605.172C536.227 605.172 566 575.361 566 538.586C566 526.037 562.533 514.299 556.506 504.279C555.082 501.912 551.945 501.389 549.693 502.986L538.267 511.09Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(499.5 566.5) rotate(-127.58) scale(476.337 498.133)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#271964"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.70634,
    stopColor: "#1C144A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.956946,
    stopColor: "#100623"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(481 549) rotate(134.35) scale(560.772 519.888)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.751174,
    stopColor: "#3C3179"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.860817,
    stopColor: "#371D6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#190A39"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464 548) rotate(-40.1331) scale(716.762 697.143)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.643467,
    stopColor: "#684DA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815386,
    stopColor: "#4B3579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.946645,
    stopColor: "#240E51"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(352 1039.5) rotate(-46.6426) scale(1344.41 1164.06)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.349891,
    stopColor: "#8F5BB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#6A5AB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1157"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 1080,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthorizationImage);
export default __webpack_public_path__ + "static/media/authorization_image.4ec51dc5ddc89ce4dd0a455298e55763.svg";
export { ForwardRef as ReactComponent };